export const DATE_FORMAT = 'DD/MM/YY';
export const DATE_FORMAT_DOTS = 'DD.MM.YY';
export const BACKEND_INPUT_DATE_FORMAT = 'YYYY/MM/DD';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY h:mmA';
export const DATE_PICKER_CONTROL_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS';
